module.exports = __webpack_public_path__ + "img/3-s.b9c78cdd.png";